var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheBoussole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6193 0.520034C8.66376 0.437216 8.72985 0.368002 8.81052 0.31975C8.89119 0.2715 8.98343 0.246019 9.07743 0.246019C9.17143 0.246019 9.26367 0.2715 9.34434 0.31975C9.42502 0.368002 9.4911 0.437216 9.53557 0.520034L13.4909 7.89326L17.2369 14.8779C17.4652 15.3038 17.0394 15.784 16.5893 15.6075L9.26687 12.7411C9.1451 12.6933 9.00976 12.6933 8.88799 12.7411L1.56585 15.6075C1.11545 15.784 0.689622 15.3038 0.918275 14.8779L4.66399 7.89492L8.6193 0.520034Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheBoussole);
export default __webpack_public_path__ + "static/media/FLECHE_boussole.ad78531b35c998451b5cc95e59af9c16.svg";
export { ForwardRef as ReactComponent };